<template>
<div style="font-size: 14px; text-align: center; max-width:100%;">
    <h2>写真アップロード機能</h2>
    <hr>
    <h3>画像を選択</h3>
    <input @change="checkImage" type="file" name="image" >
    <br>
    <div
      v-if="imgSrc !== ''"
      class="l_cropper_container mt-2"
    >
      <vue-cropper
        ref="cropper"
        :guides="true"
        :view-mode="2"
        :auto-crop-area="1"
        :min-container-width="200"
        :min-container-height="200"
        :background="true"
        :rotatable="true"
        :src="imgSrc"
        :img-style="{ 'width': '500px', 'height': '500px' }"
        drag-mode="none"
      />
      <br>
      <div>
        <div class="btn-group">
          <button type="button" class="btn btn-outline-primary" @click.prevent="rotate(90)">
              <span class="fa fa-undo-alt"></span>
          </button>
          <button type="button" class="btn btn-outline-primary" @click="rotate(-90)">
              <span class="fa fa-redo-alt"></span>
          </button>
          <button type="button" class="btn btn-outline-primary" @click.prevent="zoom(0.2)">
              <span class="fa fa-search-plus"></span>
          </button>
          <button type="button" class="btn btn-outline-primary" @click.prevent="zoom(-0.2)">
              <span class="fa fa-search-minus"></span>
          </button>
        </div>
      </div>

      <div class="mt-2">
        <!-- <button data-bs-dismiss="modal" @click="cropImage" v-if="imgSrc !== ''" style=" -->
        <button @click="cropImage" v-if="imgSrc !== ''" style="
          color: #FFF;
          background-color: #FF046C;
          border-color: #FF046C;
          cursor: pointer;
          border-radius: 0rem !important;
          line-height: 2;
          border-radius: 50rem !important;
          box-shadow:none;
          font-family: heisei-kaku-gothic-std, sans-serif;
          font-weight: 500;
          font-style: normal;
          display: inline-block;
          font-weight: 400;
          line-height: 1.5;
          text-align: center;
          text-decoration: none;
          vertical-align: middle;
          cursor: pointer;
          user-select: none;
          border: 1px solid transparent;
          padding: 0.375rem 0.75rem;
          font-size: 1rem;
          transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        ">
          トリミングする
        </button>
      </div>
    </div>
    <br>
    <br>
    <br>
  </div>

</template>

<script>
// Local

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import heic2any from "heic2any";
export default {
    props: {
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        },
        old: {
            type: Array,
            default: [""]
        },
        imageUrl: {
            type: String,
            default: null
        },
        deleteUrl: {
            type: String,
            default: null
        },
        offset: {
            type: Number,
            default: 0
        },
        apiUrl: {
            type: String,
            default: null
        },
        previewId: {
            type: String,
            default: null
        },
        formId: {
            type: String,
            default: null
        },
        maxWidth: {
            type: Number,
            default: 0
        },
        dialogId: {
            type: String,
            default: null
        },
    },
    mounted() {
    },
    data() {
        return {
            trimingFile: null,
            imgSrc: '',
            cropImg: '',
            filename: ''

        }
    },
    components: { 
        VueCropper,
    },
    methods: {
        rotateLeft() {
          console.log("rotateLeft")
          this.$refs.cropper.rotateLeft;
        },
        // 右旋转
        rotateRight() {
          console.log("rotateRight")
          this.$refs.cropper.rotateRight();
        },
        async changeHeicImage(before_file) {
            console.log("changeHeicImage")
            return heic2any({
              blob: before_file,
              toType: "image/jpeg",
              })
              .then(async (resultBlob) => {
                  console.log('changeHeicImage')
                  return resultBlob
              })
              .catch(function (x) {
                  console.log(x)
                  return
              })
        },
        checkExt(filename) {
            var allow_exts = new Array('heic', 'heif');
            //比較のため小文字にする
            var ext = this.getExt(filename).toLowerCase();
            //許可する拡張子の一覧(allow_exts)から対象の拡張子があるか確認する
            if (allow_exts.indexOf(ext) === -1) return false;
            return true;
        },
        //ファイル名から拡張子を取得する関数
        getExt(filename) {
            var pos = filename.lastIndexOf('.');
            if (pos === -1) return '';
           
            return filename.slice(pos + 1);
        },
        async checkImage(e) {
            this.imgSrc = ''
            const files = e.target.files || e.dataTransfer.files
            let file = files[0]

            if (typeof FileReader !== 'function') {
              alert('Sorry, FileReader API not supported')
              return
            }
            if (this.checkExt(file.name)) {
                file = await this.changeHeicImage(file)
            }
            if (!file || !file.type.includes('image/')) {
              alert('Please select an image file')
              return
            }
            
            this.setImage(file)
        },
        setImage (e) {
          const file = e
          this.filename = file.name

          const reader = new FileReader()
          const image = new Image()
          reader.onload = (event) => {
            image.onload = () => {
              if (this.maxWidth < image.width) {
                const canvas = document.createElement("canvas")
                const width = this.maxWidth
                const height = Math.floor(image.height * (width / image.width))
                canvas.width = width
                canvas.height = height
                const ctx = canvas.getContext('2d')
                ctx.drawImage(image, 0, 0, width, height)
                this.imgSrc = canvas.toDataURL("image/jpeg")
              } else {
                this.imgSrc = image.src
              }
            }
            image.src = event.target.result
          }
          reader.readAsDataURL(file)
        },
        cropImage () {
          this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL("image/jpeg")
          console.log(this.cropImg)
          this.trimingFile = this.cropImg
          this.setInputForm()

        },
        setInputForm() {
                // プレビュー画像を追加する要素
                const preview = document.getElementById(this.previewId);
                // ファイルが読み込まれたときに実行する
                const img = document.createElement("img"); // img要素を作成
                img.src = this.trimingFile; // 画像のURLをimg要素にセット
                preview.appendChild(img); // #previewの中に追加
                // document.getElementById(this.formId).value = this.trimingFile; //base64変換したデータを挿入
                this.updateImage(this.trimingFile)
                $(this.dialogId).hide();
        },
        async updateImage(file) {
          let formData = new FormData();
          formData.append('file', file);
          let config = {
              headers: {
                  'content-type': 'multipart/form-data'
              }
          };
          await axios
              .post(this.apiUrl, formData, config)
              .then(function(response) {
                  // response 処理
                  location.reload()
              })
              .catch(function(error) {
                  // error 処理
                  console.log(error)
                  alert('アップロードエラー')
          })
        },
        
        rotate(deg) {
          console.log("rotate")
          this.$refs.cropper.rotate(deg);
                // this.$refs.cropper.relativeZoom(0.2);

        },
        zoom(percent) {
          this.$refs.cropper.relativeZoom(percent);
        },
        


    }
}
</script>
